;(function() {
  'use strict'

  angular.module('core.questionLibrary', [])
})()
